import { Radio } from 'antd'

import { connect } from '@eastcoal/formily/exports/react'
import { FormilyProps } from '@eastcoal/formily/types/component'

const options = [
  {
    label: '左对齐',
    value: 'left'
  },
  {
    label: '水平居中',
    value: 'center'
  },
  {
    label: '右对齐',
    value: 'right'
  }
]

const Component = (props: FormilyProps) => {
  return <Radio.Group {...props} options={options} />
}

export const TextAlignRadioGroup = connect(Component)
